import VehicleHealthAdjuster from './VehicleHealthAdjuster';

export default VehicleHealthAdjuster;
export { VehicleHealthAdjuster };
